module.exports = __webpack_public_path__ + "static/keyflow2-c4ad4974f0f7080ecadbf4eca7c16f5f.mp4";